import React from 'react';
import LegalPage from './LegalPage';
import { BRAND_NAME } from '../constants/site';

const TermsPage = () => (
  <LegalPage title="Términos de uso">
    <p>
      Al utilizar el sitio web de {BRAND_NAME} aceptas estos términos. El contenido del sitio es
      informativo y no constituye un contrato vinculante hasta que se formalice un acuerdo
      comercial por escrito.
    </p>
    <p>
      Los servicios de consultoría, desarrollo y plataforma se rigen por propuestas y contratos
      específicos acordados con cada cliente, incluyendo alcance, plazos y condiciones de pago.
    </p>
    <p>
      El acceso a la plataforma {BRAND_NAME} está restringido a usuarios autorizados. Eres responsable
      de mantener la confidencialidad de tus credenciales.
    </p>
    <p>
      Nos reservamos el derecho de actualizar este sitio y estos términos. El uso continuado
      implica la aceptación de los cambios publicados.
    </p>
    <p>Última actualización: agosto 2026.</p>
  </LegalPage>
);

export default TermsPage;
